import React from 'react'

// Tách các đoạn [TEXT] ra để in đậm, giữ nguyên dấu ngoặc theo design
const BRACKET_REGEX = /(\[[^\]]+\])/g

type Props = {
  description: string
}

export const ProductInfoPricingPolicy: React.FC<Props> = ({ description }) => {
  const parts = description.split(BRACKET_REGEX).filter(Boolean)

  return (
    <div
      className='rounded-[7px] border border-primary-700 bg-primary-100/20 px-4 pb-1.5 pt-1 text-sm leading-5 text-neutral-900'
      role='note'
    >
      <p className='whitespace-pre-line break-words'>
        {parts.map((part, index) =>
          /^\[[^\]]+\]$/.test(part) ? (
            <strong key={index} className='mr-1 font-bold text-primary'>
              {part}
            </strong>
          ) : (
            <React.Fragment key={index}>{part}</React.Fragment>
          )
        )}
      </p>
    </div>
  )
}
